import {
    connect,
    compose,
    withErrorBoundary,
    loadable,
    Loader,
    ExpenseTriggers,
    withErrorMessage,
    mapProps,
} from '../dependencies';

import ExpenseDetail from '../components/ExpenseDetail';

const mapStateToProps = (state, ownProps) => {
    const { expenseTriggerId } = ownProps.match.params;
    const expenseId = ExpenseTriggers.selectors.expenseIdSelector(state, expenseTriggerId);

    return {
        expenseTriggerId,
        expenseId,
    };
};

const mapFetchExpenseTriggerToChildren = ({
    fetchExpenseTriggerApi,
    fetchExpenseTriggerRequest,
    expenseTriggerId,
    expenseId,
}) => {
    const { inProgress, success, error } = fetchExpenseTriggerApi;

    return {
        showLoader: inProgress || !success,
        error,
        onErrorMessageClick: error ? () => fetchExpenseTriggerRequest(expenseTriggerId) : null,
        expenseId,
        expenseTriggerId,
    };
};

export default compose(
    withErrorBoundary,
    connect(mapStateToProps),
    ExpenseTriggers.HOC.fetchExpenseTrigger(),
    mapProps(mapFetchExpenseTriggerToChildren),
    withErrorMessage,
    loadable(Loader),
)(ExpenseDetail);
